import { createSelector } from "reselect";
import { getVerificationServicesState } from "./root-selectors";
import { VerificationServicesState } from "@idw-types/state/verification-services-state";

export const getVerificationServicesDataState = createSelector(getVerificationServicesState, (state: VerificationServicesState) => {
	return {
        isLoadingVerificationServiceConfigurations: state.verificationServiceConfigurations.isLoading,
        verificationServiceConfigurations: state.verificationServiceConfigurations.verificationServiceConfigurations
    }
});